import { Injectable } from '@angular/core';
import WebSocket from 'ws';
@Injectable({
 providedIn: 'root',
})
export class ChatService {
  public socket: WebSocket;

  constructor() {
    this.socket = new WebSocket('http://localhost:8081/testchat');
    this.socket.onmessage = (event) => {
      console.log(`Received message => ${event.data}`);
    };
    this.socket.onopen = () => {
      console.log('Connected to the WebSocket server');
    };
    this.socket.onerror = (event) => {
      console.log('Error occurred');
    };
    this.socket.onclose = () => {
      console.log('WebSocket connection closed');
    };
  }

  sendMessage(message: string) {
    this.socket.send(message);
  }
}